<!-- Base.FieldInfo.vue (client-lms) -->
<template>
  <p class="lms_field_info">
    <i class="icon_bedge_alert"></i>
    <slot>{{ message }}</slot>
  </p>
</template>

<script setup lang="ts">
defineProps({
  message: { type: String, default: "" },
});
</script>
